var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "evaluation-card simulation-card",
      attrs: {
        id: "simualtion-card",
        animation: "slide",
        "data-cy": "simulation-data",
      },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function ({ open }) {
            return [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { role: "button", "aria-expanded": open.toString() },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _vm._v(" Datos de la simulación "),
                  ]),
                  _c(
                    "a",
                    { staticClass: "card-header-icon" },
                    [
                      _c("b-icon", {
                        attrs: { icon: open ? "minus" : "plus" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "card-block p-0" }, [
        _c(
          "div",
          { staticClass: "subcard" },
          [
            _c(
              "b-field",
              { attrs: { label: "Tipo de crédito", horizontal: "" } },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      placeholder: "Selecciona un tipo de crédito",
                      expanded: "",
                    },
                    model: {
                      value: _vm.localValue.generalParams.creditType,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localValue.generalParams,
                          "creditType",
                          $$v
                        )
                      },
                      expression: "localValue.generalParams.creditType",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "MORTAGE" } }, [
                      _vm._v("Hipotecario"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Propósito", horizontal: "" } },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      placeholder: "Selecciona un propósito",
                      expanded: "",
                    },
                    model: {
                      value: _vm.localValue.offerParams.purpose,
                      callback: function ($$v) {
                        _vm.$set(_vm.localValue.offerParams, "purpose", $$v)
                      },
                      expression: "localValue.offerParams.purpose",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "HOME" } }, [
                      _vm._v("Para vivir"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c("BInputExpanded", {
              attrs: {
                disabled: "",
                value: "0",
                label: "Pie",
                placeholder: "Ingresa valor en UF",
                prefix: "UF",
                size: "is-small",
                expanded: "",
                "prefix-position": "left",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header header-switch" },
            [
              _c(
                "b-field",
                { attrs: { label: "¿Tiene subsidio?", horizontal: "" } },
                [
                  _c("b-switch", {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      "data-cy": "hasSubsidy",
                    },
                    model: {
                      value: _vm.subsidySwitch,
                      callback: function ($$v) {
                        _vm.subsidySwitch = $$v
                      },
                      expression: "subsidySwitch",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.subsidySwitch
            ? _c(
                "div",
                { staticClass: "fields-has-text-right" },
                [
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Monto Ahorro",
                      placeholder: "Ingresa ahorro en UF",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.localValue.offerInputs.downPayment,
                      callback: function ($$v) {
                        _vm.$set(_vm.localValue.offerInputs, "downPayment", $$v)
                      },
                      expression: "localValue.offerInputs.downPayment",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Monto subsidio",
                      placeholder: "Ingresa monto subsidio en UF",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.localValue.offerInputs.subsidy,
                      callback: function ($$v) {
                        _vm.$set(_vm.localValue.offerInputs, "subsidy", $$v)
                      },
                      expression: "localValue.offerInputs.subsidy",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "subcard" },
          [
            _c("BInputExpanded", {
              attrs: {
                disabled: _vm.readOnly,
                label: "Plazo",
                placeholder: "0,00",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
              },
              model: {
                value: _vm.localValue.offerInputs.numberOfMonths,
                callback: function ($$v) {
                  _vm.$set(_vm.localValue.offerInputs, "numberOfMonths", $$v)
                },
                expression: "localValue.offerInputs.numberOfMonths",
              },
            }),
            _c("BInputExpanded", {
              attrs: {
                disabled: _vm.readOnly,
                label: "Meses de gracia",
                placeholder: "0,00",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
              },
              model: {
                value: _vm.localValue.offerInputs.numberOfGraceMonths,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.localValue.offerInputs,
                    "numberOfGraceMonths",
                    $$v
                  )
                },
                expression: "localValue.offerInputs.numberOfGraceMonths",
              },
            }),
            _c(
              "b-field",
              { attrs: { label: "¿Necesita financiar GOPs?", horizontal: "" } },
              [
                _c("b-switch", {
                  attrs: { size: "is-small", disabled: _vm.readOnly },
                  model: {
                    value: _vm.getSimulationCard.needGops,
                    callback: function ($$v) {
                      _vm.$set(_vm.getSimulationCard, "needGops", $$v)
                    },
                    expression: "getSimulationCard.needGops",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "¿Usa cuotas dobles?", horizontal: "" } },
              [
                _c("b-switch", {
                  attrs: { size: "is-small", disabled: _vm.readOnly },
                  model: {
                    value: _vm.localValue.offerInputs.useDoublePayments,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localValue.offerInputs,
                        "useDoublePayments",
                        $$v
                      )
                    },
                    expression: "localValue.offerInputs.useDoublePayments",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "¿Tiene coeudor?", horizontal: "" } },
              [
                _c("b-switch", {
                  attrs: { size: "is-small", disabled: _vm.readOnly },
                  model: {
                    value: _vm.getSimulationCard.hasCodebtor,
                    callback: function ($$v) {
                      _vm.$set(_vm.getSimulationCard, "hasCodebtor", $$v)
                    },
                    expression: "getSimulationCard.hasCodebtor",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              {
                attrs: {
                  label: "Fecha desembolso",
                  horizontal: "",
                  expanded: "",
                },
              },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      placeholder: "Selecciona una fecha",
                      expanded: "",
                    },
                    model: {
                      value: _vm.localValue.offerInputs.purchaseDate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localValue.offerInputs,
                          "purchaseDate",
                          $$v
                        )
                      },
                      expression: "localValue.offerInputs.purchaseDate",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "00-03" } }, [
                      _vm._v(" Menos de 3 meses"),
                    ]),
                    _c("option", { attrs: { value: "03-06" } }, [
                      _vm._v(" De 3 a 6 meses"),
                    ]),
                    _c("option", { attrs: { value: "06-12" } }, [
                      _vm._v(" De 6 meses a 1 año"),
                    ]),
                    _c("option", { attrs: { value: "12OrMore" } }, [
                      _vm._v(" Más de 1 año"),
                    ]),
                    _c("option", { attrs: { value: "notDefined" } }, [
                      _vm._v(" No lo se"),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }